import { Anchor, Group, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import mountayaLogoUrl from "../../assets/mountaya-logo.svg";

/**
 * MONT_WORDMARK_FF is the Mont brand typeface stack applied to the docs wordmark
 * through Mantine's `ff` style prop, which resolves to the CSS `font-family` rule.
 * A module-level constant keeps the string a stable reference and threads it
 * through Mantine's style-prop pipeline so the wordmark inherits the same theme
 * contract as the rest of the chrome.
 */
const MONT_WORDMARK_FF = '"Mont", sans-serif';

/**
 * BRAND_LOGO_HEIGHT is the logo glyph's height, matching the application's own
 * brand lockup so the two surfaces draw the same mark at the same size. The
 * header's action row derives its height from the same figure through
 * `--docs-brand-logo-height`, which is what puts the glyph on the same pixel as
 * the application's sidenav.
 */
const BRAND_LOGO_HEIGHT = 36;

/**
 * DocsBrand is the docs wordmark: the Mountaya logo beside the stacked product
 * name and "Developers" tagline, wrapping a plain anchor to the site root. The
 * docs app serves static pages with full-reload navigation, so the link is a plain
 * anchor with no client router. It is the header's leftmost element, kept as one
 * component so the brand reads identically wherever it appears.
 */
export const DocsBrand = () => {
  const { t } = useTranslation("docs");
  const { t: tCommon } = useTranslation("common");

  return (
    <Anchor aria-label={t("nav.tagline")} c="inherit" href="/" underline="never">
      <Group align="center" gap="sm">
        <img alt="" height={BRAND_LOGO_HEIGHT} src={mountayaLogoUrl} />
        <Stack gap={0}>
          <Text ff={MONT_WORDMARK_FF} fw={700} lh={1.1}>
            {tCommon("app.name")}
          </Text>
          <Text c="dimmed" lh={1.1} size="xs">
            {t("nav.tagline")}
          </Text>
        </Stack>
      </Group>
    </Anchor>
  );
};
